import VideoBlock from './VideoBlock';

function testBlock(block, contentState) {
  if (block.getType() === 'atomic') {
    const key = block.getEntityAt(0);
    return key && contentState.getEntity(key).getType() === 'VIDEO';
  }
  return false;
}

export default function blockRenderer(block, contentState, blockProps) {
  return (
    testBlock(block, contentState) && {
      component: VideoBlock,
      editable: false,
      props: blockProps,
    }
  );
}
